import { EventRegistry } from 'app/shared/events/event_registry';

export class SnappingService {
    private _onEventRegistry: EventRegistry;
    private _isSnapping = true;

    constructor() {
        this._onEventRegistry = new EventRegistry();
    }

    public get isSnapping() {
        return this._isSnapping;
    }
    public set isSnapping(value: boolean) {
        this._onEventRegistry.notifyListeners(value);
        this._isSnapping = value;
    }

    onSnappingChange(callback: (value: boolean) => void) {
        return this._onEventRegistry.addEventListener(callback);
    }
}
